const Background = () => {
    return (
        <div id="backgroundImage" className="background"></div>
    );
}

export default Background;